<template>
  <Slice>
    <div class="slicelettercampaign">
        <!-- Loading indicator -->
        <div v-if="isLoading" class="loading-indicator">
          <div class="spinner"></div>
          <span>Loading...</span>
        </div>
      <div id='Letter-Campaign' style='width: 100%'></div>
      </div>
  </Slice>
</template>

<script>

export default {
  name: "slicelettercampaign",
  props: ['item', 'slice', 'campaignId'],
  components: {},
  data() {
    return {
      type: null,
      isLoading: false,
      hasError: false,
    }
  },
  mounted() {
    this.initEmbed()
  },
  created() {
    window.addEventListener("resize", this.getWidth)
  },
  destroyed() {
    window.removeEventListener("resize", this.getWidth)
  },
  computed: {

  },
  methods: {
    initEmbed() {
      this.isLoading = true;
      this.hasError = false;
      let campaign = document.getElementById('Letter-Campaign');
      campaign.id = 'can-letter-area-' + this.slice?.primary?.campaignId;
      const style = document.createElement('link')
      style.href = 'https://actionnetwork.org/css/style-embed-v3.css'
      style.rel = 'stylesheet'
      style.type = 'text/css'
      const script = document.createElement('script');
      script.defer = true;
      script.src = 'https://actionnetwork.org/widgets/v6/letter/' + this.slice?.primary?.campaignId + '?format=js&source=widget';
      script.onload = () => this.isLoading = false;
      document.head.appendChild(style);
      document.head.appendChild(script);
    },

  }
}
</script>
<style scoped lang="scss">
.slice {

  .loading-indicator {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      color: #666;

      .spinner {
        width: 40px;
        height: 40px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

#logo_wrap{
  display: none !important;
}
</style>